<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        {{ $translate("users") | capitalize }}
      </h1>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <router-link :to="{ name: 'newUser' }">
              <b-button type="is-primary" icon-right="plus"></b-button>
            </router-link>
          </div>
          <!--<div class="level-item">
            <b-button
              type="is-primary"
              icon-right="delete"
              :disabled="checkedRows.length == 0"
              @click="deleteSelectedOccurrencies()"
            ></b-button>
          </div>-->
        </div>
        <div class="level-right">
          <b-field>
            <b-input
              :placeholder="$translate('search').concat('...') | capitalize"
              type="search"
              icon="magnify"
              v-model="queryString"
              @keyup.native.enter="searchData()"
            ></b-input>
          </b-field>
        </div>
      </div>
      <b-table
        :data="filteredData"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        default-sort="user.first_name"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        checkable
      >
        <template slot-scope="props">
          <!--b-table-column field="id" label="ID" width="50">
            {{ props.row.id }}
          </b-table-column>-->
          <b-table-column
            field="userInfo.name"
            :label="$translate('name') | capitalize"
            sortable
          >
            {{ props.row.userInfo.name }}
          </b-table-column>
          <b-table-column
            field="userInfo.surname"
            :label="$translate('surname') | capitalize"
            sortable
          >
            {{ props.row.userInfo.surname }}
          </b-table-column>
          <b-table-column
            field="email"
            :label="$translate('mail') | capitalize"
            sortable
          >
            {{ props.row.email }}
          </b-table-column>
          <b-table-column
            field="typeString"
            :label="$translate('type') | capitalize"
            sortable
          >
            {{ props.row.typeString }}
          </b-table-column>
          <b-table-column
            field="userInfo.customers"
            :label="$translate('customers') | capitalize"
          >
            {{ props.row.userInfo.customers }}
          </b-table-column>
          <b-table-column
            field="userInfo.mercurio_id"
            :label="$translate('id_mercury') | capitalize"
            sortable
          >
            {{ props.row.userInfo.mercurio_id }}
          </b-table-column>
          <b-table-column
            field="username"
            :label="$translate('username') | capitalize"
            sortable
          >
            {{ props.row.username }}
          </b-table-column>
          <!--<b-table-column
            field="language"
            :label="$translate('language') | capitalize"
            >{{ props.row.language }}</b-table-column
          >-->
          <b-table-column :label="$translate('action') | capitalize">
            <a
              @click="
                $router.push({
                  name: 'editUser',
                  params: { id: props.row.userInfo.id },
                })
              "
            >
              <b-icon icon="pencil-outline"></b-icon>
            </a>
            <a @click="deleteOccurrence(props.row.userInfo.id)">
              <b-icon icon="delete-outline"></b-icon>
            </a>
            <!--<a
              @click="
                $router.push({
                  name: 'newOrder',
                  params: { patientId: props.row.id }
                })
              "
            >
              <b-icon icon="plus"></b-icon>
            </a>-->
          </b-table-column>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import firebase from "firebase";

export default {
  name: "users",
  data() {
    return {
      tableData: [],
      filteredData: [],
      loading: true,
      page: 1,
      total: 0,
      sortField: "vote_count",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      checkedRows: [],
      queryString: "",

      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 10,
    };
  },
  methods: {
    searchData() {
      this.filteredData = [];
      // eslint-disable-next-line no-useless-escape
      let regexp = new RegExp(`\w*${this.queryString}\w*`, `gmi`);
      this.tableData.forEach((user) => {
        if (user.username.match(regexp)) {
          this.filteredData.push(user);
        } else if (
          user.userInfo.mercurio_id &&
          user.userInfo.mercurio_id.match(regexp)
        ) {
          this.filteredData.push(user);
        } else if (user.userInfo.name && user.userInfo.name.match(regexp)) {
          this.filteredData.push(user);
        } else if (
          user.userInfo.surname &&
          user.userInfo.surname.match(regexp)
        ) {
          this.filteredData.push(user);
        } else if (user.email && user.email.match(regexp)) {
          this.filteredData.push(user);
        }
      });
    },
    loadAsyncData() {
      this.loading = true;
      this.$db
        .collection("users")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let user = doc.data();
            user.id = doc.id;
            this.$db
              .collection("usersInfo")
              .where("email", "==", user.email)
              .get()
              .then((snap) => {
                snap.forEach((doc) => {
                  user.userInfo = doc.data();
                  user.userInfo.id = doc.id;
                  user.typeString = user.userInfo.type;
                  if (user.userInfo.level) {
                    user.typeString += " " + user.userInfo.level;
                  }
                  if (
                    user.userInfo.type == "A" ||
                    user.userInfo.companiesId.find((el) => el === "*")
                  ) {
                    user.userInfo.customers = this.$translate("all");
                    this.tableData.push(user);
                  } else if (user.userInfo.companyId) {
                    this.$db
                      .collection("companies")
                      .doc(user.userInfo.companyId)
                      .get()
                      .then((doc) => {
                        if (doc.data()) {
                          user.userInfo.customers = doc.data().name;
                        }
                        this.tableData.push(user);
                      });
                  } else {
                    let baseRequest = this.$db.collection("companies");
                    let promises = [];
                    for (
                      let i = 0;
                      i < user.userInfo.companiesId.length;
                      i += 10
                    ) {
                      promises.push(
                        baseRequest
                          .where(
                            firebase.firestore.FieldPath.documentId(),
                            "in",
                            user.userInfo.companiesId.slice(i, i + 10)
                          )
                          .get()
                      );
                    }
                    user.userInfo.customers = "";
                    Promise.all(promises).then((companiesSnapshots) => {
                      companiesSnapshots.forEach((companiesSnapshot) => {
                        companiesSnapshot.forEach((doc) => {
                          user.userInfo.customers += `${doc.data().name}, `;
                        });
                      });
                      user.userInfo.customers = user.userInfo.customers.substring(
                        0,
                        user.userInfo.customers.length - 2
                      );
                      this.tableData.push(user);
                    });
                  }
                });
                this.filteredData = this.tableData;
                this.loading = false;
              });
          });
        });
    },
    onPageChange(page) {
      this.page = page;
      this.loadAsyncData();
    },
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.loadAsyncData();
    },
    deleteOccurrence(id) {
      this.$buefy.dialog.confirm({
        title: this.$translate("attention"),
        message: this.$translate("delete_confirm_text"),
        cancelText: this.$translate("undo"),
        confirmText: this.$translate("delete"),
        onConfirm: async () => {
          const userInfoDoc = await this.$db.collection("usersInfo").doc(id).get();
          const email = userInfoDoc.data().email;

          const usersSnap = await this.$db
            .collection("users")
            .where("email", "==", email)
            .get();

          const batch = this.$db.batch();
          batch.delete(this.$db.collection("usersInfo").doc(id));
          usersSnap.forEach((doc) => batch.delete(doc.ref));
          await batch.commit();

          this.tableData = this.tableData.filter((el) => el.userInfo.id !== id);
          this.filteredData = this.filteredData.filter((el) => el.userInfo.id !== id);
        },
      });
    },
  },
  mounted() {
    switch (this.$store.getters.user.userInfo.type) {
      case "A":
        break;
      default:
        this.$router.push("/forbidden");
        break;
    }
    this.loadAsyncData();
  },
};
</script>
